var ANALYTICS_WRAPPER_CLASS = 'search-results-analytics-container';
var ANALYTICS_SECTION_CLASS = 'search-results-analytics-section';
var ANALYTICS_RESULT_CLASS = 'search-result-analytics-result';

export { ANALYTICS_RESULT_CLASS, ANALYTICS_SECTION_CLASS, ANALYTICS_WRAPPER_CLASS };
//# sourceMappingURL=analyticsConstants.js.map
